import '../../styles.global.css';
import '../../assets/styles/Divider.module.css';

var styles = {"divider":"wru__Divider__divider","major":"wru__Divider__major wru__Divider__divider","major_light":"wru__Divider__major_light wru__Divider__divider","minor":"wru__Divider__minor wru__Divider__divider","dashed":"wru__Divider__dashed wru__Divider__divider"};

export { styles as default };
//# sourceMappingURL=Divider.module.scss.js.map
